export const LIVESTREAM_SECONDS = {
  ASSIMILATED_LIVE: 4,
  SECURED_DVR: 2,
}

export const LIVESTREAM_STATUS = {
  LOADING: 'loading',
  WAITING: 'waiting',
  STREAMING: 'streaming',
  ENDED: 'ended',
}
